import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';

const DesignTabContent = () => {
	const intl = useIntl();

	const gwp9473JSWAnchorUpdates = checkFeatureFlagGate(featureFlags.gwp9473JSWAnchorUpdates);

	const designHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.design.header',
			defaultMessage: 'Unleash innovative design work with Jira',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/stwkq56nns422b0684fodlf0074s3b6e.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.design.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira design ticket',
			}),
		},
	};

	const gwp9473JSWAnchorUpdatesHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.hero.design.header',
			defaultMessage: 'Design with all the right context',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2s7dw8mxw65kwtjh2npm8x55200kcnu3.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeaturesGwp9473Updates.design.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira board view',
			}),
		},
	};

	return (
		<PaidHeroTabPanelTemplate
			{...(gwp9473JSWAnchorUpdates ? gwp9473JSWAnchorUpdatesHeroProps : designHeroProps)}
		/>
	);
};

export default DesignTabContent;
